export default {
    "-1x0": "west",
    "1x0": "east",
    "0x-1": "north",
    "0x1": "south",
}
